"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeteorStormAbilityHandler = exports.MeteorStormActorAbilityFactory = exports.MeteorStormAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Random_1 = require("../../utils/Random");
class MeteorStormAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.MeteorStorm;
        this.__typeName = "MeteorStorm";
    }
}
exports.MeteorStormAbilityArgs = MeteorStormAbilityArgs;
let MeteorStormActorAbilityFactory = class MeteorStormActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("MeteorStorm", "AllEnemies", 2);
    }
};
MeteorStormActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("MeteorStorm")
], MeteorStormActorAbilityFactory);
exports.MeteorStormActorAbilityFactory = MeteorStormActorAbilityFactory;
let MeteorStormAbilityHandler = class MeteorStormAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                jitter: (0, Random_1.random)(25, 75),
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Fire", 60)
                ],
            })),
            onHitOrMiss: (sequence, { targetId }, { hit }) => sequence.push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet")
                : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "MeteorStrike"))
        });
    }
};
MeteorStormAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.MeteorStorm)
], MeteorStormAbilityHandler);
exports.MeteorStormAbilityHandler = MeteorStormAbilityHandler;
